//MOUSE ANIMATIONS
var mouse = document.getElementById('mouse');

/*
document.addEventListener('mousemove', function(e) {
  let left = e.pageX;
  let top = e.pageY;
  mouse.style.left = left + 'px';
  mouse.style.top = top + 'px';
});
*/

handleMouseMove = (event) => {
  const y = event.pageY;
  const x = event.pageX;
  const scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
  const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  mouse.style.left =  x - scrollLeft + 'px';
  mouse.style.top = y - scrollTop + 'px';
};
document.addEventListener("mousemove", handleMouseMove, false);

const hovers = document.querySelectorAll(".btn-hover");
hovers.forEach(
  function(hover){
    hover.addEventListener("mouseenter", () => mouse.classList.add("btn-highlight"));
    hover.addEventListener("mouseleave", () => mouse.classList.remove("btn-highlight"));
  }
);

const hoversCollection = document.querySelectorAll(".btn-collection");
hoversCollection.forEach(
  function(hoverCollection){
    hoverCollection.addEventListener("mouseenter", function(){
      mouse.classList.add("btn-collection");
      $("#mouse .image").css("background-image", "url(" + hoverCollection.getAttribute("data-image") + ")");
    });
    hoverCollection.addEventListener("mouseleave", function(){
      mouse.classList.remove("btn-collection");
    });
  }
);


const hoversProduct = document.querySelectorAll(".btn-card-prod");
hoversProduct.forEach(
  function(hoverProduct){
    hoverProduct.addEventListener("mouseenter", function(){
      mouse.classList.add("btn-text");
      $("#mouse .text").html(hoverProduct.getAttribute("data-text"));
    });
    hoverProduct.addEventListener("mouseleave", function(){
      mouse.classList.remove("btn-text");
      //$("#mouse .text").html("");
    });
  }
);


const hoversPattern = document.querySelectorAll(".btn-pattern");
hoversPattern.forEach(
  function(hoverPattern){
    hoverPattern.addEventListener("mouseenter", function(){
      mouse.classList.add("btn-pattern");
      $("#mouse .image").css("background-image", "url(" + hoverPattern.getAttribute("data-image") + ")");
    });
    hoverPattern.addEventListener("mouseleave", function(){
      mouse.classList.remove("btn-pattern");
    });
  }
);


const btns = document.querySelectorAll(".btn-arr");
btns.forEach(
  function(btn){
    btn.addEventListener("mouseenter", () => mouse.classList.add("btn-hover"));
    btn.addEventListener("mouseleave", () => mouse.classList.remove("btn-hover"));
  }
);

const swipes = document.querySelectorAll(".btn-swipe");
swipes.forEach(
  function(swipe){
    swipe.addEventListener("mouseenter", () => mouse.classList.add("btn-swipe"));
    swipe.addEventListener("mouseleave", () => mouse.classList.remove("btn-swipe"));
  }
);

const shops = document.querySelectorAll(".btn-shop");
shops.forEach(
  function(shop){
    shop.addEventListener("mouseenter", () => mouse.classList.add("btn-shop"));
    shop.addEventListener("mouseleave", () => mouse.classList.remove("btn-shop"));
  }
);